import type { ApiType } from 'types/api_type';

export const organizationsApi: Readonly<ApiType> = {
  path: '/organizations',
};

export const organizationsAccessibilityApi: Readonly<ApiType> = {
  path: `${organizationsApi.path}/accessibility`,
};

export const organizationsSignInApi: Readonly<ApiType> = {
  path: `${organizationsApi.path}/sign_in`,
};

export const organizationsEditApi: Readonly<ApiType> = {
  path: `${organizationsApi.path}`,
};
